import { render, staticRenderFns } from "./cryptoForm.vue?vue&type=template&id=95dd580c"
import script from "./cryptoForm.vue?vue&type=script&lang=js"
export * from "./cryptoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports